// This is the expected name of the input variable for every process node
export const INPUT_VARIABLE_NAME = 'input__';

// This prefix is used to identify variables or regions scoped to the full calculation model.
// E.g. "global__param" identifies a global variable
export const GLOBAL_SCOPE_PREFIX = 'global';
